// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__25joX","footer":"Form_footer__vqf1s"};